<template>
    <component :is="template">
        <v-container>
            <div class="contents-area">
                <div class="contents-area__inner">
                    <div class="tit-wrap mb-0">
                        <h2 class="tit">캐시 리워드</h2>
                        <div class="font-size-14 font-size-md-16 grey--text text--garken-3">
                            미션을 수행하고 캐시 리워드를 적립받을 수 있습니다.
                        </div>
                    </div>

                    <v-divider class="my-6 my-lg-12" />

                    <offerwall-info />

                    <v-img src="/images/offerwall/offerwall-1.jpg" />
                    <v-img src="/images/offerwall/offerwall-2.jpg" />

                    <offerwall-down />

                    <v-divider class="my-6 my-lg-12" />
                    <v-row class="row--small" justify="center">
                        <v-col :cols="$vuetify.breakpoint.mobile ? '6' : 'auto'">
                            <v-btn v-bind="{ loading }" rounded large block color="primary" class="white--text w-lg-240px" @click="go">
                                <span> 미션하고 적립받기 </span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </v-container>
        <v-bottom-sheet :value="shows" fullscreen persistent>
            <v-card flat>
                <v-card-title>
                    <span> 캐시 리워드 </span>
                    <v-spacer />
                    <v-icon @click="href = undefined">mdi-close</v-icon>
                </v-card-title>
                <v-divider />
                <iframe v-bind="props_iframe" />
            </v-card>
        </v-bottom-sheet>
        <offerwall-noti v-bind="{ shows }" />
    </component>
</template>
<script>
import api from "@/api";

import OfferwallDown from "@/components/client/offerwall/offerwall-down.vue";
import OfferwallInfo from "@/components/client/offerwall/offerwall-info.vue";
import OfferwallNoti from "@/components/client/offerwall/offerwall-noti.vue";

export default {
    components: {
        OfferwallDown,
        OfferwallInfo,
        OfferwallNoti,
    },
    data: () => ({
        href: undefined,
        loading: false,
    }),
    computed: {
        shows() {
            return !!this.href;
        },
        template() {
            return () => import(`@/templates/${this.$theme.pages.gshop}`);
        },
        _user() {
            return this.$store.state.payload?._user;
        },
        props_iframe() {
            return {
                src: this.href,
                width: "100%",
                style: {
                    height: "calc(100vh - 57px)",
                    border: "none",
                },
            };
        },
    },
    methods: {
        async go() {
            if (this._user) {
                if (this.loading) return;
                else this.loading = true;

                try {
                    let appcode = "MXkvnvwHPK";
                    let app_uid = this._user;
                    let { androidAdvertisingId: adid, receivedIDFA: idfa } = window;

                    await api.v1.me.greenp.offerwall.logs.post({ appcode, app_uid, adid, idfa });

                    let baseHref = `https://api.greenp.kr/quiz_offerwall.html?appcode=${appcode}&app_uid=${app_uid}`;

                    if (adid) {
                        this.href = `${baseHref}&adid=${adid}`;
                    } else if (idfa) {
                        this.href = `${baseHref}&idfa=${idfa}`;
                    } else {
                        this.href = baseHref;
                    }
                    if (!this.shows) location.href = this.href;
                } finally {
                    this.loading = false;
                }
            } else {
                alert("로그인 후 사용할 수 있는 기능입니다");
                this.$router.push("/login");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.contents-area {
    margin: -30px -24px;
    @media (min-width: 768px) {
        margin: -40px -24px;
    }
    @media (min-width: 1024px) {
        margin: 0;
        padding: 60px 114px;
    }
    &__inner {
        @media (max-width: 1023px) {
            padding: 20px 38px;
        }
    }
}

.exchange-list-item-card__overlay {
    position: absolute;
    bottom: 0;
    width: 100%;

    align-items: end;
    justify-content: stretch;

    &::v-deep .v-overlay__content {
        width: 100%;
    }
}
</style>
